import dateFormat from 'date-fns/format';
import toDate from 'date-fns/toDate';

/**
 * Takes a date string (w/o a time) and reformats it.
 *
 * @param dateString The date string to reformat into the desired format.
 * @param format The desired outout format, see https://date-fns.org/v2.29.2/docs/format
 */
export default function formatDateString(
  dateString: string,
  format?: string
): string {
  const formatted = dateFormat(
    toDate(new Date(`${dateString}T12:00:00.000`)),
    format || 'MMMM dd, yyyy'
  );

  return formatted;
}
